import { defineTokens } from '@chakra-ui/react/styled-system';

import object from './sizesAndSpacing.json';

const spacing = defineTokens.spacing(object);

export default spacing;
